import clsx from 'clsx'

import styles from './icon.module.css'
import type { IconDefaultProps } from './types'

const ChevronDown = ({ className }: IconDefaultProps): JSX.Element => (
  <svg
    aria-hidden='true'
    focusable='false'
    className={clsx('svg-inline--fa fa-chevron-down', styles.icon, className)}
    data-prefix='fal'
    data-icon='chevron-down'
    role='img'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 448 512'>
    <path
      fill='currentColor'
      d='M4.251 181.1C7.392 177.7 11.69 175.1 16 175.1c3.891 0 7.781 1.406 10.86 4.25l197.1 181.1l197.1-181.1c6.5-6 16.64-5.625 22.61 .9062c6 6.5 5.594 16.59-.8906 22.59l-208 192c-6.156 5.688-15.56 5.688-21.72 0l-208-192C-1.343 197.7-1.749 187.6 4.251 181.1z'></path>
  </svg>
)

export default ChevronDown
